import FormLogIn from 'components/FormLogIn';
import FormInputValidation from 'components/FormLogIn/components/FormInputValidation';
import Introduction from 'components/FormLogIn/components/Introduction';
import FormLogInMobile from 'components/FormLogIn/mobile';
import {
  checkFormInputValidation,
  getGreetingText,
} from 'components/common/func';
import {
  DESKTOP_MIN_WIDTH,
  LOGIN_EMAIL_NAME,
  LOGIN_FIELDS,
  LOGIN_PASSWORD_NAME,
  LOGIN_UNAUTHORIZED_INFORM,
  RESET_LOGIN_INFORMATION,
} from 'constants';
import useForm from 'hooks/form/useForm';
import useAuth from 'hooks/useAuth';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { useRef, useState } from 'react';
import { SET_SHOW_LOADING } from 'store/action';
import styled from 'styled-components';
import EventIcon from '../../assets/icons/event-icon.svg';
import SizeBox from 'components/common/SizeBox';

const LoginPage = () => {
  const { t } = useLang();
  const { isMobile, isTablet, isDesktop } = useDetectDevice();
  const { isHHMTTheme } = useTheme();
  const { dispatch } = useStore();
  const { login } = useAuth();
  // const { locate } = useLang();

  const {
    information,
    setInformation,
    validation,
    setValidation,
    checkAllowSubmit,
  } = useForm(RESET_LOGIN_INFORMATION);

  const [error, setError] = useState('');

  // const noticeContent = t('login_text_introduce_3');
  // const externalLink = t('login_text_notice_external_url');
  // const noticeDisplay =
  //   noticeContent !== 'login_text_introduce_3' ? true : false;
  // const hasExternalLink =
  //   externalLink !== 'login_text_notice_external_url' ? true : false;

  // const terms = t('label_terms_conditions_text_01');
  // const hasTerms = terms !== 'label_terms_conditions_text_01' ? true : false;

  const noticeTxt = isHHMTTheme
    ? t('login_text_notice_hhmt')
    : t('login_text_notice_remox');
  const hasNoticeTxt =
    noticeTxt !== ('login_text_notice_hhmt' || 'login_text_notice_remox')
      ? true
      : false;

  const terms = isHHMTTheme
    ? t('login_text_notice_term_hhmt')
    : t('login_text_notice_term_remox ');
  const hasTerms =
    terms !== ('login_text_notice_term_hhmt' || 'login_text_notice_term_remox ')
      ? true
      : false;

  const handleSubmitError = (error) => {
    setError(error?.response?.data?.message?.toLowerCase());

    dispatch({ type: SET_SHOW_LOADING, payload: false });
  };

  const handleSubmit = async () => {
    let newValidation = { ...validation };

    LOGIN_FIELDS.forEach((field) => {
      newValidation = checkFormInputValidation(
        information[field.name],
        field,
        newValidation,
      );
    });

    setValidation(newValidation);

    const isAllowSubmit = checkAllowSubmit({
      information,
      validation: newValidation,
    });

    if (isAllowSubmit) {
      dispatch({ type: SET_SHOW_LOADING, payload: true });
      try {
        const error = await login(
          information[LOGIN_EMAIL_NAME],
          information[LOGIN_PASSWORD_NAME],
        );

        handleSubmitError(error);
      } catch (error) {
        checkMaintenance(error);
        console.error(error?.message);
        handleSubmitError(error);
      }
      return;
    }
  };

  const renderNotice = () => {
    if (!hasNoticeTxt) return null;
    return (
      <Notice
        dangerouslySetInnerHTML={{
          __html: noticeTxt,
        }}
      />
    );
  };
  const renderTerms = () => {
    if (!hasTerms) return null;
    return (
      <Terms
        dangerouslySetInnerHTML={{
          __html: terms,
        }}
      />
    );
  };

  const renderFormInputValidations = () => {
    return (
      <>
        {LOGIN_FIELDS.map((field) => (
          <FormInputValidation
            key={field.name}
            field={field}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
            error={error}
            setError={setError}
          />
        ))}
        {LOGIN_UNAUTHORIZED_INFORM[error]}
        {isDesktop && <SizeBox height={16} />}
      </>
    );
  };

  const targetDateRef = useRef(Date.now());
  const handlePaytoAccountAuthoriseCheckStatus = (
    countdownCallback = FUNC_DEFAULT,
  ) => {
    console.log(`⭐ useCountdownToActionVer3 👉 countdownCallback RUNNING ↩`);
    countdownCallback?.();
  };
  // const { totalSeconds, minutes, seconds } = useCountdownToActionVer3({
  //   secsInit: 5,
  //   nowRef: targetDateRef,
  //   // isLoop: true,
  //   onComplete: handlePaytoAccountAuthoriseCheckStatus,
  // });

  const { showPortalModalName } = usePortalModal();
  // const openotp = () => {
  //   showPortalModalName({
  //     name: PORTAL_NAME_MODAL_DEFINE.PAYTO_OTP_VERIFICATION_MODAL,
  //     action: () => {},
  //     modalData: {},
  //   });
  // };
  // const opencreateagreementsuccess = () => {
  //   showPortalModalName({
  //     name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_SUCCESS_MODAL,
  //     action: () => {},
  //     modalData: {},
  //   });
  // };
  // const opencreateagreementreject = () => {
  //   showPortalModalName({
  //     name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_REJECT_MODAL,
  //     action: () => {},
  //     modalData: {},
  //   });
  // };
  // const opencreateagreementtimeout = () => {
  //   showPortalModalName({
  //     name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_TIMEOUT_MODAL,
  //     action: () => {},
  //     modalData: {},
  //   });
  // };
  // const { setPending } = useCommonStore();

  if (isMobile || isTablet) {
    return (
      <LoginPageStyled>
        {/* <button onClick={openotp}>click to open OTP modal</button> */}
        {/* <button onClick={opencreateagreementsuccess}>click to open Create agreement success modal</button> */}
        {/* <button onClick={() => setPending(true)}>click to pending</button> */}
        {/* <Paragraph>totalSeconds={totalSeconds}</Paragraph>
        <Paragraph>minutes={minutes}</Paragraph>
        <Paragraph>seconds={seconds}</Paragraph> */}
        <Title>{getGreetingText()}</Title>
        <Paragraph>{t('login_text_greeting_2')}</Paragraph>
        {renderNotice()}
        {renderTerms()}
        <FormLogInMobile
          renderFormInputValidations={renderFormInputValidations}
          handleSubmit={handleSubmit}
        />
      </LoginPageStyled>
    );
  }
  return (
    <LoginPageStyled>
      {/* <button onClick={openotp}>click</button> */}
      {/* <button onClick={opencreateagreementsuccess}>click to open Create agreement success modal</button> */}
      {/* <button onClick={opencreateagreementreject}>
        click to open Create agreement reject modal
      </button> */}
      {/* <button onClick={opencreateagreementtimeout}>
        click to open Create agreement timeout modal
      </button> */}
      <Introduction />
      <FormWrap>
        <Title>{getGreetingText()}</Title>
        <Paragraph>{t('login_text_greeting_2')}</Paragraph>
        {renderNotice()}
        {renderTerms()}
        <FormLogIn
          noticeDisplay={hasNoticeTxt}
          renderFormInputValidations={renderFormInputValidations}
          handleSubmit={handleSubmit}
        />
      </FormWrap>
    </LoginPageStyled>
  );
};

const LoginPageStyled = styled.div`
  padding: 24px;
  padding-top: 94px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding: 0;
    display: grid;
    grid-template-columns: 55% 45%;
    align-items: end;
    margin-block: auto;
  }

  @media screen and (min-width: 1440px) {
    grid-template-columns: 60% 40%;
    margin-block: 100px auto;
  }

  @media screen and (min-width: 1920px) {
    margin-block: 90px auto;
  }

  @media screen and (min-width: 2560px) {
    margin-block: 148px auto;
  }
`;

const FormWrap = styled.div`
  background: var(--ds-c-white);
  box-shadow: 0px 4px 15px rgb(0 0 0 / 12%);
  border-radius: 40px;

  @media screen and (min-width: 1280px) {
    padding: 24px;
    width: 485px;
    height: 558px;
  }

  @media screen and (min-width: 1440px) {
    padding: 40px;
    width: 517px;
    height: 659px;
  }
`;

const Title = styled.h1`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 800;
  text-transform: capitalize;

  color: var(--ds-c-grey-dark);
  margin-bottom: 8px;

  @media screen and (min-width: 1280px) {
    font-size: 30px;
    line-height: 35px;
  }

  @media screen and (min-width: 1440px) {
    font-size: 40px;
    line-height: 50px;
  }
`;

const Paragraph = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);
  margin-bottom: 20px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 24px;
  }
`;

const Notice = styled.div`
  background-image: url(${EventIcon});
  background-position: 13px 13px;
  background-size: 50px 41px;
  background-repeat: no-repeat;

  width: 100%;
  height: auto;
  min-height: 61px;
  padding: 8px 24px 10px 74px;
  background-color: #fef0d1;
  border-radius: 8px;
  margin-bottom: 12px;

  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  a,
  span {
    color: var(--ds-c-grey-dark);
    vertical-align: -webkit-baseline-middle;
  }
`;

const Terms = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);
  margin-bottom: 20px;

  a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

export default LoginPage;
